import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"

const STATUS_COLORS = {
  stable: tokens.color.success,
  new: tokens.color.success,
  experimental: tokens.color.accent,
  review: tokens.color.accent,
  deprecated: tokens.color.error,
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${tokens.size.base}px ${0.5 * tokens.size.base}px;
  border: 1px solid ${tokens.color.border};
  border-radius: ${tokens.color.bgLight};
`
function getStatusColor(status) {
  return STATUS_COLORS[status.toLowerCase()] || tokens.color.bgInput
}

function StatusLabel({ status }) {
  return (
    <StyledContainer>
      <span
        style={{
          color: getStatusColor(status),
          marginRight: tokens.size.base + "px",
        }}
      >
        &#8226;
      </span>
      <span>{status}</span>
    </StyledContainer>
  )
}

StatusLabel.propTypes = {
  status: PropTypes.string,
}

export default StatusLabel
